(ns bp-clients.tv-app.auth.subs
  "Namespace for all auth subscriptions"
  (:require [bp-clients.tv-app.auth.events :as auth-events]
            [re-frame.core :refer [reg-sub]]))

(defn auth-sub
  [db]
  (get db ::auth-events/auth))

(defn login-sub
  "Checks spec and selects nav path interceptor"
  [db]
  (get db :login))

(defn token-sub
  "Given the app state retuns the user token"
  [user]
  (get user :token))

(defn logged-in-sub
  "Given the app state returns whether a user is logged in"
  [uid]
  (seq uid))

(defn qr-code-sub
  "Given the app state returns whether a user is logged in"
  [login]
  (:qr-url login))

(defn login-code-sub
  "Given the app state returns whether a user is logged in"
  [login]
  (:code login))

(defn user-sub
  [db]
  (get db :user))

(defn user-profile-sub
  [user]
  (get user :profile))

(defn fatal-login-error-sub
  [login]
  (-> login
      :error?
      true?))

(reg-sub ::auth auth-sub)
(reg-sub ::user :<- [::auth] user-sub)
(reg-sub ::token :<- [::user] token-sub)
(reg-sub ::login :<- [::auth] login-sub)
(reg-sub ::login-code :<- [::login] login-code-sub)
(reg-sub ::qr-code-url :<- [::login] qr-code-sub)
(reg-sub ::fatal-login-error? :<- [::login] fatal-login-error-sub)
(reg-sub ::logged-in? :<- [::token] logged-in-sub)
(reg-sub ::user-profile :<- [::user] user-profile-sub)
